import { render, staticRenderFns } from "./HWP_BuildingPokaz.vue?vue&type=template&id=44f69e48&scoped=true&"
import script from "./HWP_BuildingPokaz.vue?vue&type=script&lang=js&"
export * from "./HWP_BuildingPokaz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f69e48",
  null
  
)

export default component.exports